"use strict";
exports.__esModule = true;
exports.evaluateJSONPointer = void 0;
var escaping_1 = require("./escaping");
var validateJSONPointer_1 = require("./validateJSONPointer");
function evaluateJSONPointer(jsonPointer, document) {
    (0, validateJSONPointer_1.validateJSONPointer)(jsonPointer);
    if (jsonPointer === '') {
        return document;
    }
    var referenceTokens = jsonPointer.slice(1).split('/');
    var value = document;
    for (var _i = 0, referenceTokens_1 = referenceTokens; _i < referenceTokens_1.length; _i++) {
        var referenceToken = referenceTokens_1[_i];
        value = value && value[(0, escaping_1.unescapeReferenceToken)(referenceToken)];
    }
    return value;
}
exports.evaluateJSONPointer = evaluateJSONPointer;
